import { render, staticRenderFns } from "./TableStickyColumnsHeaders.vue?vue&type=template&id=62c394b4&"
import script from "./TableStickyColumnsHeaders.vue?vue&type=script&lang=js&"
export * from "./TableStickyColumnsHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports